<template>
  <div class="md-layout">
    <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100 header truncated_header m-0">
      <div class="md-layout md-alignment-center">
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-60 p-0">
          <h1 class="title-h4-formatting">{{ this.headerData.title + ': ' }}</h1>
          <ul>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">business_center</i>Industry: </p>
              <p>[{{ parseFloat(this.headerData.bznaics) }}] {{ this.headerData.industry }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">apartment</i>Sector: </p>
              <p>{{ this.headerData.sector }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">place</i>Market Area: </p>
              <p>{{ this.headerData.area }}</p>
            </li>
            <li>
              <p class="sub-title-formatting"><i class="md-icon md-icon-dark-blue">equalizer</i>Sales Class: </p>
              <p>{{ this.headerData.sales_class }}</p>
            </li>
          </ul>
        </div>
        <div class="md-layout-item md-medium-size-100 md-xsmall-size-40 md-size-40 button-box">
          <md-button class="md-info access-button pdf_btn" @click="feedback"><md-icon>comment</md-icon>Product Feedback</md-button>
          <md-button v-if="!profile || !profile.years" class="md-info access-button pdf_btn">
            <template><md-icon class="ml-5">picture_as_pdf</md-icon>Loading...</template>
          </md-button>
          <md-button v-if="pdfLoading" class="md-info access-button pdf_btn">
            <template><md-icon class="ml-5">picture_as_pdf</md-icon>Downloading...</template>
          </md-button>
          <md-button v-if="profile && profile.years && !this.pdfGenerating" target="_blank" class="md-info access-button pdf_btn" @click="downloadPDFDataAPI">
            <md-icon class="ml-5">picture_as_pdf</md-icon>
            Download PDF
          </md-button>
          <md-button v-if="this.pdfGenerating" :class="'md-info access-button pdf_btn'"><md-icon class="ml-5">picture_as_pdf</md-icon>Generating...</md-button>

          <md-button :class="!profile || !profile.years ? 'md-info access-button csv_btn disabled' : 'md-info access-button pdf_btn'" @click.native="downloadCSVData">
            <md-icon class="ml-5">receipt_long</md-icon>
            {{ (!profile || !profile.years) ? 'Loading...' : 'Download CSV' }}
          </md-button>
        </div>
        <div class="md-layout-item md-size-100" v-if="colouredLineChart"></div>
      </div>
    </div>
    <modal v-if="feedbackModal" @close="feedbackModal = false" class="feedback_modal">
      <template slot="body">
        <button type="button" class="close_btn" @click="feedbackModal = false">
          <md-icon>clear</md-icon>
        </button>
        <h3 class="modal-title">Have feedback on this product?</h3>
        <p>Enter the details below to send your feedback to our Product Team.</p>
        <form action class="form_grp">
          <div class="field_wpr">
            <label>Leave A Feedback Note</label>
            <textarea v-model="textFeedback" placeholder="Type a message"></textarea>
            <md-button @click="sendFeedback" class="md-info md-round mt-4">Send Feedback</md-button>
            <div class="md-layout-item">
              <md-checkbox v-model="checkBoxOption1">1 - Report An Error</md-checkbox>
              <md-checkbox v-model="checkBoxOption2" class="pl-3">2 - Suggest an Improvement</md-checkbox>
              <md-checkbox v-model="checkBoxOption3">3 - Request a Correction</md-checkbox>
              <md-checkbox v-model="checkBoxOption4">4 - Request an Update</md-checkbox>
            </div>
          </div>
        </form>
      </template>
    </modal>
    <IFPDF ref="ifPDF" :headerInfo="headerData" :information="{ tableDataFirmsAnalyzed, colouredLineChart, naicsDrilldown }" :valMultiples="{ multiplesA, multiplesB, multiplesC, multiplesAll }"/>
  </div>
</template>
<script>
import {Modal} from '@/components';
import {mapState, mapActions} from 'vuex';
import formatData from '@/mixins/format-data';
import IFPDF from './_partials/IFPDF.vue';
import axios from 'axios';

export default {
  components: {
    Modal,
    IFPDF
  },
  mixins: [formatData],
  props: ['headerData'],
  data() {
    return {
      checkBoxOption1: null,
      checkBoxOption2: null,
      checkBoxOption3: null,
      checkBoxOption4: null,
      category: null,
      userIP: null,
      feedbackModal: false,
      textFeedback: '',
      tableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
      multiplesTableInfo: [
        {
          id: 'Low',
          name: 'Q1',
        },
        {
          id: 'Med',
          name: 'Median',
        },
        {
          id: 'High',
          name: 'Q3',
        },
      ],
      colouredLineChart: {
        data: {
          labels: [],
          series: [],
        },
        options: {
          axisY: {
            showGrid: true,
            offset: 40,
          },
          axisX: {
            showGrid: false,
          },
          low: 0,
          showPoint: true,
          height: '300px',
        },
      },
      naicsDrilldown: {},
      tableDataFirmsAnalyzed: [],
      filtered_years: [],
      filtered_firms: [],
      filtered_PLDollar: [],
      filtered_PLPercent: [],
      filtered_BSDollar: [],
      filtered_BSPercent: [],
      cashflow: [],
      cashFlowFilteredData: [],
      efficiency: [],
      efficiencyFilteredData: [],
      profitability: [],
      profitabilityFilteredData: [],
      turnover: [],
      debtRiskFilteredData: [],
      changein: [],
      changeinFilteredData: [],
      worksheet: [],
      worksheetFilteredData: [],
      sales_class_csv: '',
      pdfFile: this.pdfFile || "/if_profile.pdf",
      pdfURL: null,
      pdfGenerating: false
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.user.user,
      multiplesA: (state) => {
        return state.user.profile['multiples_A']
            ? state.user.profile['multiples_A']
            : [];
      },
      multiplesB: (state) => {
        return state.user.profile['multiples_B']
            ? state.user.profile['multiples_B']
            : [];
      },
      multiplesC: (state) => {
        return state.user.profile['multiples_B']
            ? state.user.profile['multiples_B']
            : [];
      },
      multiplesAll: (state) => {
        return state.user.profile['multiples_all']
            ? state.user.profile['multiples_all']
            : [];
      },
      data: (state) => state.user.profile.data,
      profile: (state) => state.user.profile,
      pdfLoading: (state) => state.user.pdfLoading,
      PLtable: (state) => state.user.profile.tables['PL'],
      BStable: (state) => state.user.profile.tables['BS'],
      tables: (state) => state.user.profile.tables['ratios'],
      tablesInfo: (state) => state.user.profile.tables['ratioInfo'],
      sourcesUses: (state) => state.user.profile['sourcesUses'],
      sourceYears: (state) => state.user.profile['sourcesUses']['years'],
      release_display: (state) => state.user.profile.release_display,
      bznaics_code: (state) => state.user.profile.bznaics,
      sector_name: (state) => state.user.profile.data[0].sector,
      industry_title: (state) => state.user.profile.data[0].industry,
      sales_class: (state) => state.user.profile.data[0].sales_class,
      display_area: (state) => state.user.profile.data[0].display_area,
    }),
    sourceTablesInfo() {
      return _.omit(this.sourcesUses, 'years');
    },
    filteredProfile() {
      return Object.values(this.profile.data).filter((item) => item);
    },
    getCsvData() {
      let csvData = [
        ['Industry Financial Profile'],
        ['"Release Date"', this.release_display],
        [''],
        ['Segment', 'Industry'],
        [this.industry_title],
        ['[' + parseInt(this.bznaics_code) + ']' + ' Sector', this.sector_name],
        ['Market', this.headerData.area],
        ['Sales Class', this.sales_class],
        [''],
      ];
      csvData.push(['Firms Analyzed', this.filtered_years]);
      csvData.push(['', this.filtered_firms]);
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss($)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Income and Expense - Profit and Loss(%)']);
      csvData.push(['', this.filtered_years]);
      this.filtered_PLPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet($)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSDollar.forEach((e, i) => {
        if (typeof e === 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
        if (Array.isArray(e) && e[0] === 'Total Assets') {
          csvData.push(['Liabilities']);
        }
      });
      csvData.push(['']);
      csvData.push(['Balance Sheet(%)']);
      csvData.push(['Assets', this.filtered_years]);
      this.filtered_BSPercent.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
        if (Array.isArray(e) && e[0] === 'Total Assets') {
          csvData.push(['Liabilities']);
        }
      });
      csvData.push(['']);
      csvData.push(['Financial Ratios: Cash Flow-Solvency']);
      csvData.push(['', this.filtered_years]);
      this.cashFlowFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Profitability']);
      csvData.push(['', this.filtered_years]);
      this.profitabilityFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Efficiency']);
      csvData.push(['', this.filtered_years]);
      this.efficiencyFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Financial Ratios: Debt-Risk']);
      csvData.push(['', this.filtered_years]);
      this.debtRiskFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Sources & Uses of Funds']);
      csvData.push(['', this.sourceYears]);
      this.changeinFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      csvData.push(['Worksheet:']);
      this.worksheetFilteredData.forEach((e, i) => {
        if (typeof e == 'string' && e.includes(',')) {
          e = e.replace(/,/g, '');
        }
        csvData.push(e);
      });
      // ------------------- Valuation -------------------------
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['']);
      csvData.push(['Valuation Multiples']);
      csvData.push(['Sales Group: < $2.5m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesA[`Sales${item.id}`], this.multiplesA[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: $2.5m - $24.9m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesB[`Sales${item.id}`], this.multiplesB[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: > $25m:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesC[`Sales${item.id}`], this.multiplesC[`Earnings${item.id}`]]);
      });
      csvData.push(['']);
      csvData.push(['Sales Group: All:']);
      csvData.push(['', 'Sales Multiples', 'Earnings Multiples']);
      this.multiplesTableInfo.forEach((item, index) => {
        csvData.push([item.name, this.multiplesAll[`Sales${item.id}`], this.multiplesAll[`Earnings${item.id}`]]);
      });
      return csvData;
    },
    filteredData() {
      return Object.values(this.data).filter((item) => item);
    },
    actualData() {
      return this.filteredData[0]['cashflow'];
    },
  },
  watch: {
    profile() {
      // this.parseCSVData();
      this.initData();
      //this.generatePDFData();
    },
    checkBoxOption1(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = '1';
      }
    },
    checkBoxOption2(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption3 = false;
        this.checkBoxOption4 = false;
        this.category = '2';
      }
    },
    checkBoxOption3(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption4 = false;
        this.category = '3';
      }
    },
    checkBoxOption4(newVal, oldVal) {
      if (newVal) {
        this.checkBoxOption1 = false;
        this.checkBoxOption2 = false;
        this.checkBoxOption3 = false;
        this.category = '4';
      }
    }
  },
  mounted() {
    this.$store.commit('user/SET_PDF_LOADING', false);
    this.initData();
  },
  methods: {
    ...mapActions({
      downloadPDFfromAPI: 'pdf/download',
      registerProductExport: 'tracking/registerProductExport',
    }),
    resetValues() {
      this.filtered_years = [];
      this.filtered_firms = [];
      this.filtered_PLDollar = [];
      this.filtered_PLPercent = [];
      this.filtered_BSDollar = [];
      this.filtered_BSPercent = [];
      this.cashflow = [];
      this.cashFlowFilteredData = [];
      this.efficiency = [];
      this.efficiencyFilteredData = [];
      this.profitability = [];
      this.profitabilityFilteredData = [];
      this.turnover = [];
      this.debtRiskFilteredData = [];
      this.changein = [];
      this.changeinFilteredData = [];
      this.worksheet = [];
      this.worksheetFilteredData = [];
      this.sales_class_csv = '';
    },
    initData() {
      if (!this.profile || !this.profile.years) {
        return;
      }
      this.resetValues();
      this.getUserIP();
      this.profile.years.forEach((e, i) => {
        //this.filtered_years.push(Number(e));
        this.filtered_years.push(e);
      });
      this.init();
      let firmData = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({...item, firms: item.firms}));
      firmData.forEach((element) => {
        this.filtered_firms.push(parseFloat(element.firms));
      });
      this.filtered_firms.reverse();
      if (this.sales_class.includes(',')) {
        this.sales_class_csv = this.sales_class.replace(/,/, '');
      }
      let PLdollar = this.formatTable(this.PLtable, 'industry', 'dollar');
      let PLpercent = this.formatTable(this.PLtable, 'industry', 'percent');
      PLdollar.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_PLDollar.push(v);
      });
      PLpercent.forEach((element) => {
        if (element.name.includes(',')) {
          element.name = element.name.replace(/,/g, '');
        }
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_PLPercent.push(v);
      });
      let BSdollar = this.formatTable(this.BStable, 'industry', 'dollar');
      let BSpercent = this.formatTable(this.BStable, 'industry', 'percent');
      BSdollar.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.name);
        this.filtered_BSDollar.push(v);
      });
      BSpercent.forEach((element) => {
        let z = Object.values(element.dates);
        let v = [];
        z.forEach((item, i) => {
          if (typeof item === 'string' && item.includes(',')) {
            item = parseFloat(item.replace(/,/g, ''));
          }
          v.push(item);
        });
        v.unshift(element.name);
        this.filtered_BSPercent.push(v);
      });
      if (!_.isEmpty(this.tables)) {
        Object.entries(this.tables).forEach(
            ([table, data]) => (this[table] = this.formatTable(data, 'industry'))
        );
      }
      let cashFlowData = [];
      this.cashflow.forEach((element, index) => {
        if (element.name in this.tables['cashflow']) {
          cashFlowData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      cashFlowData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.cashFlowFilteredData.push(v);
      });
      let efficiencyData = [];
      this.efficiency.forEach((element, index) => {
        if (element.name in this.tables['efficiency']) {
          efficiencyData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      efficiencyData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.efficiencyFilteredData.push(v);
      });
      let profitabilityData = [];
      this.profitability.forEach((element, index) => {
        if (element.name in this.tables['profitability']) {
          profitabilityData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      profitabilityData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.profitabilityFilteredData.push(v);
      });
      let debtRiskData = [];
      this.turnover.forEach((element, index) => {
        if (element.name in this.tables['turnover']) {
          debtRiskData.push({
            dates: element.dates,
            title: this.tablesInfo[element.name]['title'],
          });
        }
      });
      debtRiskData.forEach((element) => {
        let k = Object.values(element.dates);
        let v = [];
        k.forEach((e, i) => {
          if (typeof e === 'string' && e.includes(',')) {
            e = parseFloat(e.replace(/,/g, ''));
          }
          v.push(e);
        });
        v.unshift(element.title);
        this.debtRiskFilteredData.push(v);
      });
      Object.entries(this.sourceTablesInfo).forEach(([table, data]) =>
          this.$set(this, table, this.formatSourcesData(table, data))
      );
      this.changein.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.changeinFilteredData.push(k);
      });
      this.worksheet.forEach((element, index) => {
        let k = [];
        Object.values(element.dates).forEach((e, index) => {
          k.push(e);
        });
        k.unshift(element.title);
        this.worksheetFilteredData.push(k);
      });
    },
    sendFeedback() {
      if (this.category) {
        let currentSession = localStorage.getItem(
            "vue-authenticate.vueauth_access_token"
        );
        axios
            .post(
                process.env.VUE_APP_API_BASE_URL + '/user/feedback/submit',
                {},
                {
                  params: {
                    session_id: currentSession,
                    feedback: this.textFeedback,
                    ip: `${this.userIP}`,
                    url: `${window.location.href}`,
                    category: this.category
                  },
                }
            )
            .then((res) => {
              if (res.hasOwnProperty('data') && res.data.error) {
                this.$store.commit('SET_ERROR_BIT', true);
                this.$store.commit(
                    'SET_ERROR_INFO',
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode +
                    `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
                );
                throw new Error(
                    '<br>' +
                    'Server responded with error = True <br> errorCode: ' +
                    res.data.errorCode
                );
              }
              if (res.data.success)
                this.$store.dispatch('alerts/success', "Data saved.");
              else
                this.$store.dispatch('alerts/error', "An error occured. please try again");
              this.feedbackModal = false;
              this.textFeedback = null;
              this.category = null;
              this.checkBoxOption1 = false;
              this.checkBoxOption2 = false;
              this.checkBoxOption3 = false;
              this.checkBoxOption4 = false;
            });
      } else {
        this.$store.commit('SET_ERROR_BIT', true);
        this.$store.commit(
            'SET_ERROR_INFO',
            '<br>' +
            'Server responded with error = True <br> errorCode: ' +
            'category_not_set' +
            `<br> ${process.env.VUE_APP_API_BASE_URL} + "/user/feedback/submit" <br>`
        );
      }
    },
    getUserIP() {
      try {
        fetch('https://api.ipify.org?format=json', {
          mode: 'no-cors'
        })
            .then(x => x.json())
            .then(({ip}) => {
              this.userIP = ip;
            });
      } catch (err) {
      }
    },
    init() {
      this.tableDataFirmsAnalyzed = Object.values(this.profile.data)
          .filter((item) => item)
          .map((item) => ({...item, firms: this.numberWithCommas(item.firms)}));
      this.tableDataFirmsAnalyzed = _.orderBy(
          this.tableDataFirmsAnalyzed,
          ['year'],
          ['asc']
      );
      this.naicsDrilldown = this.profile.naicsDrilldown;
      this.colouredLineChart.data = {
        labels: this.profile.years,
        series: [this.filteredProfile.map((item) => item.firms)],
      };
    },
    numberWithCommas(x) {
      if (x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      } else {
        return x;
      }
    },
    feedback() {
      this.feedbackModal = true;
    },
    generatePDFData() {
      // PDF API generating
      let data = {};
      data.type = 'ifp';
      data.report = this.profile;
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfURL = res.pdf_data;
        this.pdfGenerating = false;
      });
    },
    downloadPDFData() {
      // PDF API download

      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: 'PDF'
      });

      if (this.$route.query.pdftest) {
        window.open('https://com-bizminer-application-fileupload.s3.amazonaws.com/pdfs/test.pdf', '_blank');
      } else {
        // PDF frontend download
        this.$store.commit('user/SET_PDF_LOADING', true);
        this.$refs.ifPDF.generateReport();
      }
    },
    downloadPDFDataAPI() {
      // PDF API download
      this.pdfGenerating = true;

      let data = {};
      data.type = 'ifp';
      data.report = this.profile;
      this.$store.dispatch('pdf/download', data).then(async (res) => {
        this.pdfGenerating = false;

        if(res.pdf_success) {
          window.open(res.pdf_data, '_blank');
        }
      });
    },
    downloadCSVData() {
      let csv = '';
      this.getCsvData.forEach((row) => {
        csv += row.join(',');
        csv += '\n';
      });
      const anchor = document.createElement('a');
      anchor.href = 'data:text/csv;charset=utf-8,' + encodeURIComponent(csv);
      anchor.target = '_blank';
      anchor.download = 'Industry Financial Profile.csv';
      anchor.click();
      this.registerProductExport({
        userId: this.user?.userID,
        productId: this.$route.params.id,
        exportType: 'CSV'
      })
    },
    formatSourcesData(table, data) {
      let getDates = (id) =>
          this.sourceYears.reduce((acc, cur, index) => {
            let value = this.actualData[this.sourceYears.length - index - 1][id];
            value = isNaN(Number(value)) ? value : Number(value.toFixed(0));
            return {...acc, [cur]: value};
          }, {});
      return data.map((item) => ({
        ...item,
        dates: getDates(item.id),
      }));
    },
  },
};
</script>
<style lang="scss">
.introduction-body {
  display: flex;
  align-items: flex-start;
}

.introduction-title {
  display: flex;
  flex-direction: column;
  justify-content: end;
}
</style>
